<template>
    <results-block mode="tickets"></results-block>
</template>

<script>
import ResultsBlock from '@tv/components/partials/results/ResultsBlock';

export default {
    components: { ResultsBlock },
}
</script>
